import { memo, useCallback } from 'react';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import DailyGiftAwarded from '../DailyGiftAwarded/DailyGiftAwarded';
import DailyGiftPending from '../DailyGiftPending/DailyGiftPending';
import { claimDailyGift } from '../../state/dailyGift.slice';
import { useDispatch } from '@betty/toolkit/state';
import useDailyGift from '../../hooks/useDailyGift';
import { Lottie } from '@betty/moonlight';

function DailyGift() {
  const dispatch = useDispatch();
  const { dailyGift, dailyGiftStatus, claimDailyGiftDataState } =
    useDailyGift();

  const handleClaim = useCallback(async () => {
    if (dailyGift?.playerRewardId) {
      const result = await dispatch(claimDailyGift(dailyGift.playerRewardId));

      if (claimDailyGift.fulfilled.match(result)) {
        Lottie.present({ animation: 'confetti' });
      }
    }
  }, [dailyGift, dispatch]);

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleGoToShop = () => {
    navigation.navigate('Shop');
  };

  if (dailyGiftStatus === 'Pending') {
    return (
      <DailyGiftPending
        isClaiming={Boolean(claimDailyGiftDataState.match('pending'))}
        handleClaim={handleClaim}
      />
    );
  }

  if (dailyGiftStatus === 'Awarded' && dailyGift?.rewardAmount) {
    return (
      <DailyGiftAwarded
        rewardAmount={dailyGift?.rewardAmount}
        nextAvailableAt={dailyGift?.nextAvailableAt}
        handleGoToShop={handleGoToShop}
      />
    );
  }

  return null;
}

export default memo(DailyGift);
